import type { AnalyticsRecord, AnalyticsMetrics } from './types';

export function adaptAnalyticsRecord(raw: unknown): AnalyticsRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<AnalyticsRecord>;
  return {
    site_id: String(data.site_id || ''),
    pageviews_30d: Number(data.pageviews_30d || 0),
    unique_visitors_30d: Number(data.unique_visitors_30d || 0),
    conversion_rate_pct: Number(data.conversion_rate_pct || 0),
    lcp_p75_ms: Number(data.lcp_p75_ms || 0),
    cls_p75: Number(data.cls_p75 || 0),
    inp_p75_ms: Number(data.inp_p75_ms || 0),
  };
}

export function adaptAnalyticsMetrics(rec: AnalyticsRecord): AnalyticsMetrics {
  return {
    pageviews30d: rec.pageviews_30d,
    uniqueVisitors30d: rec.unique_visitors_30d,
    conversionRatePct: rec.conversion_rate_pct,
    lcpP75Ms: rec.lcp_p75_ms,
    clsP75: rec.cls_p75,
    inpP75Ms: rec.inp_p75_ms,
  };
}
